import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ProcessingModalService {
  private _isProcessing = new BehaviorSubject<boolean>(false);
  private _processingMessage = new BehaviorSubject<string>('Processing data...');
  private _isCompleted = new BehaviorSubject<boolean>(false);

  public isProcessing$ = this._isProcessing.asObservable();
  public processingMessage$ = this._processingMessage.asObservable();
  public isCompleted$ = this._isCompleted.asObservable();

  constructor(private translate: TranslateService) { }

  showProcessing(messageKey: string = 'processing-modal.processing-data'): void {
    // Try instant first, if it returns the key, use get() as fallback
    let translatedMessage = this.translate.instant(messageKey);
    
    if (translatedMessage === messageKey) {
      // Translation not ready, use get() to wait for it
      this.translate.get(messageKey).subscribe(msg => {
        this._processingMessage.next(msg);
      });
    } else {
      // Translation is ready, use it immediately
      this._processingMessage.next(translatedMessage);
    }
    
    this._isProcessing.next(true);
    this._isCompleted.next(false);
  }

  hideProcessing(): void {
    this._isProcessing.next(false);
    this._isCompleted.next(false);
  }

  showCompletion(): void {
    this._isCompleted.next(true);
    // Auto-hide after showing completion for 1 second
    setTimeout(() => {
      this.hideProcessing();
    }, 1000);
  }

  get isProcessing(): boolean {
    return this._isProcessing.value;
  }

  get processingMessage(): string {
    return this._processingMessage.value;
  }

  get isCompleted(): boolean {
    return this._isCompleted.value;
  }
}
